export default __webpack_public_path__ + "assets/3c4ea7157699f261db60955ea29b76c9.svg";